import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function QRCodeModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-wood-800/60 backdrop-blur-sm" onClick={onClose}>
      <div
        className="bg-cream-50 border border-cream-300 rounded-3xl p-8 max-w-sm mx-4 text-center shadow-warm-lg"
        onClick={e => e.stopPropagation()}
      >
        <h3 className="font-serif text-terracotta-500 text-xl mb-6">
          Scannez pour commander
        </h3>

        {/* QR code placeholder */}
        <div className="bg-white rounded-2xl p-4 inline-block mb-6 shadow-warm border border-cream-200">
          <svg width="160" height="160" viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="8" width="40" height="40" fill="none" stroke="#332A1C" strokeWidth="6"/>
            <rect x="18" y="18" width="20" height="20" fill="#332A1C"/>
            <rect x="112" y="8" width="40" height="40" fill="none" stroke="#332A1C" strokeWidth="6"/>
            <rect x="122" y="18" width="20" height="20" fill="#332A1C"/>
            <rect x="8" y="112" width="40" height="40" fill="none" stroke="#332A1C" strokeWidth="6"/>
            <rect x="18" y="122" width="20" height="20" fill="#332A1C"/>
            <rect x="56" y="8" width="8" height="8" fill="#332A1C"/>
            <rect x="72" y="8" width="8" height="8" fill="#332A1C"/>
            <rect x="88" y="8" width="8" height="8" fill="#332A1C"/>
            <rect x="56" y="24" width="8" height="8" fill="#332A1C"/>
            <rect x="80" y="24" width="8" height="8" fill="#332A1C"/>
            <rect x="96" y="24" width="8" height="8" fill="#332A1C"/>
            <rect x="64" y="40" width="8" height="8" fill="#332A1C"/>
            <rect x="88" y="40" width="8" height="8" fill="#332A1C"/>
            <rect x="8" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="24" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="40" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="64" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="80" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="104" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="120" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="144" y="56" width="8" height="8" fill="#332A1C"/>
            <rect x="8" y="72" width="8" height="8" fill="#332A1C"/>
            <rect x="32" y="72" width="8" height="8" fill="#332A1C"/>
            <rect x="56" y="72" width="8" height="8" fill="#332A1C"/>
            <rect x="72" y="72" width="8" height="8" fill="#332A1C"/>
            <rect x="96" y="72" width="8" height="8" fill="#332A1C"/>
            <rect x="112" y="72" width="8" height="8" fill="#332A1C"/>
            <rect x="136" y="72" width="8" height="8" fill="#332A1C"/>
            <rect x="8" y="88" width="8" height="8" fill="#332A1C"/>
            <rect x="24" y="88" width="8" height="8" fill="#332A1C"/>
            <rect x="48" y="88" width="8" height="8" fill="#332A1C"/>
            <rect x="72" y="88" width="8" height="8" fill="#332A1C"/>
            <rect x="88" y="88" width="8" height="8" fill="#332A1C"/>
            <rect x="120" y="88" width="8" height="8" fill="#332A1C"/>
            <rect x="144" y="88" width="8" height="8" fill="#332A1C"/>
            <rect x="8" y="96" width="8" height="8" fill="#332A1C"/>
            <rect x="40" y="96" width="8" height="8" fill="#332A1C"/>
            <rect x="64" y="96" width="8" height="8" fill="#332A1C"/>
            <rect x="96" y="96" width="8" height="8" fill="#332A1C"/>
            <rect x="128" y="96" width="8" height="8" fill="#332A1C"/>
            <rect x="56" y="112" width="8" height="8" fill="#332A1C"/>
            <rect x="80" y="112" width="8" height="8" fill="#332A1C"/>
            <rect x="104" y="112" width="8" height="8" fill="#332A1C"/>
            <rect x="120" y="112" width="8" height="8" fill="#332A1C"/>
            <rect x="144" y="112" width="8" height="8" fill="#332A1C"/>
            <rect x="56" y="128" width="8" height="8" fill="#332A1C"/>
            <rect x="72" y="128" width="8" height="8" fill="#332A1C"/>
            <rect x="96" y="128" width="8" height="8" fill="#332A1C"/>
            <rect x="112" y="128" width="8" height="8" fill="#332A1C"/>
            <rect x="136" y="128" width="8" height="8" fill="#332A1C"/>
            <rect x="56" y="144" width="8" height="8" fill="#332A1C"/>
            <rect x="80" y="144" width="8" height="8" fill="#332A1C"/>
            <rect x="88" y="144" width="8" height="8" fill="#332A1C"/>
            <rect x="120" y="144" width="8" height="8" fill="#332A1C"/>
            <rect x="144" y="144" width="8" height="8" fill="#332A1C"/>
          </svg>
        </div>

        <p className="text-wood-500 text-sm mb-2">
          Scannez ce QR code avec votre telephone
        </p>
        <a
          href="https://cartoucherie.gotomarket.click"
          target="_blank"
          rel="noopener noreferrer"
          className="text-terracotta-500 text-sm hover:underline"
        >
          cartoucherie.gotomarket.click
        </a>

        <button
          onClick={onClose}
          className="mt-6 w-full py-3 rounded-full bg-cream-100 border border-cream-300 text-wood-600 hover:bg-cream-200 hover:border-terracotta-400 transition-all text-sm font-medium"
        >
          Fermer
        </button>
      </div>
    </div>
  );
}

export default function Welcome() {
  const [qrOpen, setQrOpen] = useState(false);

  return (
    <div className="min-h-screen bg-cream-50 flex flex-col relative">

      {/* Sticky QR banner */}
      <div className="sticky top-0 z-40 bg-cream-50/95 backdrop-blur-sm border-b border-cream-300">
        <div className="max-w-lg mx-auto px-4 py-2.5 flex items-center justify-center gap-2">
          <svg className="w-4 h-4 text-terracotta-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM17 14h0m0 3h0m-3-3h0m3 3h0" />
          </svg>
          <span className="text-wood-500 text-xs">
            Scannez le QR code sur votre table
          </span>
        </div>
      </div>

      {/* QR button - top right */}
      <div className="absolute top-14 right-4 z-30">
        <button
          onClick={() => setQrOpen(true)}
          className="bg-cream-50 border-2 border-terracotta-400 rounded-2xl p-3 hover:bg-terracotta-500 hover:text-white transition-all group shadow-warm"
          aria-label="Afficher le QR code"
        >
          <svg className="w-6 h-6 text-terracotta-500 group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6.75h.75v.75h-.75zM6.75 16.5h.75v.75h-.75zM16.5 6.75h.75v.75H16.5zM13.5 13.5h.75v.75h-.75zM13.5 19.5h.75v.75h-.75zM19.5 13.5h.75v.75h-.75zM19.5 19.5h.75v.75h-.75zM16.5 16.5h3v3h-3z" />
          </svg>
        </button>
      </div>

      {/* Hero section with banner image */}
      <div className="relative w-full h-64 sm:h-80 overflow-hidden">
        <img
          src="https://halles-cartoucherie.fr/wp-content/uploads/2023/08/Halles-header.jpg"
          alt="Les Halles de la Cartoucherie"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Warm overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-wood-800/60 via-wood-800/50 to-cream-50" />

        {/* Text over hero */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <h1 className="font-serif text-white text-4xl sm:text-5xl leading-tight drop-shadow-lg">
            Les Halles
            <br />
            de la Cartoucherie
          </h1>
          <p className="text-cream-200 text-lg mt-3 font-light tracking-wide">
            Toulouse
          </p>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center px-6 py-8">
        <div className="text-center max-w-md w-full">

          {/* Warm tagline */}
          <p className="font-serif text-terracotta-500 text-xl sm:text-2xl mb-10 italic">
            Bienvenue dans notre marche couvert
          </p>

          {/* How it works */}
          <div className="mb-10">
            <p className="text-wood-500 text-sm mb-5 font-medium">Comment ca marche</p>

            <div className="bg-white rounded-3xl p-6 shadow-warm border border-cream-200 text-left space-y-5">
              <div className="flex items-start gap-4">
                <span className="bg-terracotta-500 text-white rounded-full w-9 h-9 flex items-center justify-center font-serif text-lg flex-shrink-0">
                  1
                </span>
                <div>
                  <p className="text-wood-800 text-sm font-semibold">Parcourez les stands 🧀</p>
                  <p className="text-wood-500 text-xs mt-0.5">Composez votre commande multi-stands</p>
                </div>
              </div>

              <div className="h-px bg-cream-200" />

              <div className="flex items-start gap-4">
                <span className="bg-terracotta-500 text-white rounded-full w-9 h-9 flex items-center justify-center font-serif text-lg flex-shrink-0">
                  2
                </span>
                <div>
                  <p className="text-wood-800 text-sm font-semibold">Payez en une seule fois 🍷</p>
                  <p className="text-wood-500 text-xs mt-0.5">Un seul paiement pour tous les stands</p>
                </div>
              </div>

              <div className="h-px bg-cream-200" />

              <div className="flex items-start gap-4">
                <span className="bg-terracotta-500 text-white rounded-full w-9 h-9 flex items-center justify-center font-serif text-lg flex-shrink-0">
                  3
                </span>
                <div>
                  <p className="text-wood-800 text-sm font-semibold">Recuperez au stand 🍕</p>
                  <p className="text-wood-500 text-xs mt-0.5">Notification quand c'est pret</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-4">
            <Link
              to="/order"
              className="block w-full bg-terracotta-500 text-white font-semibold text-lg px-10 py-4 rounded-full hover:bg-terracotta-600 hover:shadow-warm-lg transition-all duration-300 shadow-warm"
            >
              Decouvrir les stands
            </Link>

            <button
              onClick={() => setQrOpen(true)}
              className="w-full flex items-center justify-center gap-3 bg-white border border-cream-300 text-wood-600 font-medium text-sm px-8 py-3.5 rounded-full hover:border-terracotta-400 hover:text-terracotta-500 transition-all duration-300 shadow-warm"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6.75h.75v.75h-.75zM6.75 16.5h.75v.75h-.75zM16.5 6.75h.75v.75H16.5zM13.5 13.5h.75v.75h-.75zM13.5 19.5h.75v.75h-.75zM19.5 13.5h.75v.75h-.75zM19.5 19.5h.75v.75h-.75zM16.5 16.5h3v3h-3z" />
              </svg>
              Scanner le QR code de votre table
            </button>
          </div>

          {/* Footer */}
          <div className="mt-16 pt-6 border-t border-cream-200">
            <Link to="/stand-login" className="text-wood-400 text-xs hover:text-terracotta-500 transition-colors">
              Acces Back-Office
            </Link>
          </div>
        </div>
      </div>

      {/* QR Code Modal */}
      <QRCodeModal isOpen={qrOpen} onClose={() => setQrOpen(false)} />
    </div>
  );
}
